<template>
    <v-dialog v-model="open_dialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="justify-space-between">
          <div>ไม่พบข้อมูล</div>
          <div class="cursor_icon_pos_table_detail" @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </div>
        </v-card-title>
  
        <v-card-text>
          <div class="d-flex">
            <div class="flex-grow-1 mr-1">
              กรุณาลองใหม่อีกครั้ง
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="d-flex align-center">
            <v-btn
              height="40"
              color="#28ab28"
              class="white--text"
              @click="retry"
            >
              ลองใหม่
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    props: {
      is_retry: Boolean,
      value: Boolean,
    },
    data() {
      return {
        open_dialog: this.value,
      };
    },
    watch: {
      value(val) {
        this.open_dialog = val;
      },
      open_dialog() {
        
      },
    },
    methods: {
      closeDialog() {
        this.$emit("retry", true);  
      },
      retry() {
        this.$emit("retry", true); 
      },
    },
  };
  </script>
  
  <style scoped></style>
  